import { render, staticRenderFns } from "./page-auth.vue?vue&type=template&id=2b4d6733&scoped=true"
import script from "./page-auth.vue?vue&type=script&lang=js"
export * from "./page-auth.vue?vue&type=script&lang=js"
import style0 from "./page-auth.vue?vue&type=style&index=0&id=2b4d6733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d6733",
  null
  
)

export default component.exports